import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    standalone: false,
    selector: '[titlecase]'
})
export class TitleCaseDirective {
    private el = inject(ElementRef);

    @HostListener('input')
    onInput() {
        const text: string = this.el.nativeElement.value;

        if (text && text.length > 0) {

            if (text.length == 1)
                this.el.nativeElement.value = text[0].toLocaleUpperCase();

            this.el.nativeElement.value = text[0].toLocaleUpperCase() + text.substring(1, text.length);
        }
    }
}